export const departmentIcons = {
  business: '/static/images/pages/careers/jobs/business.svg',
  engineering: '/static/images/pages/careers/jobs/engineering.svg',
  design: '/static/images/pages/careers/jobs/design.svg',
  marketing: '/static/images/pages/careers/jobs/marketing.svg',
  operations: '/static/images/pages/careers/jobs/operations.svg',
  people: '/static/images/pages/careers/jobs/people.svg',
  finance: '/static/images/pages/careers/jobs/finance.svg',
  product: '/static/images/pages/careers/jobs/product.svg',
  sales: '/static/images/pages/careers/jobs/sales.svg',
  legal: '/static/images/pages/careers/jobs/legal.svg',
  security: '/static/images/pages/careers/jobs/security.svg',
  federal: '/static/images/pages/careers/jobs/federal.svg',
  it: '/static/images/pages/careers/jobs/security.it'
};
